<template>
    <div class="jr-component">
      <div class="jr-datetimewhere">
        <span class="jr-display-name">
        {{ components.controlDisplayname }}
      </span>
      
      <el-input :title="componentValue.controlDefaultvalue" class="jr-input" v-bind="$attrs" :readonly="false" :id="components.controlId" :size="size" v-model="componentValue.controlDefaultvalue" :disabled="!components.controlRighttype || components.controlReadonly" prefix-icon="el-icon-date" placeholder="请选择日期">
        <template slot="append"><div @click="showDialog = true" class="hand-pointer"><i class="el-icon-more"></i></div></template>
      </el-input> 

      <el-dialog title="选择日期"  center :visible.sync="showDialog" :close-on-click-modal="true" :append-to-body="true" width="445px">
        <div>
          <el-date-picker :size="size" v-model="beginDate" type="datetime" placeholder="开始日期" :disabled="beginDisabled" style="width: 185px;" :clearable="false" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <i style="text-align:center" class="el-icon-minus"></i>         
          <el-date-picker :size="size" v-model="endDate" type="datetime" placeholder="结束日期" :disabled="endDisabled" style="width: 185px;" :clearable="false" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <div style="width: 100%; padding-top: 30px; display: flex; flex-direction: row ; justify-content: center; align-items:center;">
            <el-radio-group @change="radioChange" v-model="radio">
              <el-radio :label="3">小于</el-radio>
              <el-radio :label="6">介于</el-radio>
              <el-radio :label="9">大于</el-radio>
            </el-radio-group>    
          </div> 
        </div>        
        <span slot="footer" class="dialog-footer">
          <el-button @click="clear">取 消</el-button>
          <el-button type="primary" @click="ok">确 定</el-button>
        </span>
      </el-dialog>
      <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/> 
    </div>
    </div>
</template>
<script>
export default {
  name: 'JrDatetimewhere',
  computed: {
    componentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  created() {
    var now = new Date();
    const year = now.getFullYear(); //得到年份
    const month = now.getMonth() + 1;//得到月份
    const date = now.getDate();//得到日期2020-02-11 00:00:00
    this.beginDate = year + '-' + month + '-' + date + ' 00:00:00'
    this.endDate = year + '-' + month + '-' + date + ' 23:59:59'
  },
  data() {
    return {
      showDialog: false,
      beginDisabled: false,
      endDisabled: false,
      beginDate: '',
      endDate: '',
      radio: 6
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    size: {
      type: String,
      default: 'small'
    }
    
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    radioChange(e){
      if(e == 3){
        this.beginDisabled = true
        this.endDisabled = false
        this.beginDate = '1900-01-01 00:00:00'
        return
      }
      if(e == 6){
        this.beginDisabled = false
        this.endDisabled = false
        var now = new Date();
        const year = now.getFullYear(); //得到年份
        const month = now.getMonth() + 1;//得到月份
        const date = now.getDate();//得到日期2020-02-11 00:00:00
        this.beginDate = year + '-' + month + '-' + date + ' 00:00:00'
        this.endDate = year + '-' + month + '-' + date + ' 23:59:59'
        return
      }
      if(e == 9){
        this.beginDisabled = false
        this.endDisabled = true
        this.endDate = '2999-12-31 23:59:59'
        return
      }
    },
    clear(){
      this.componentValue.controlDefaultvalue = ''
      this.showDialog = false
    },
    ok(){
      if(this.beginDate != '' && this.endDate != ''){
        this.componentValue.controlDefaultvalue = this.beginDate + '/' + this.endDate
        this.showDialog = false
      }
      
    }
  }
}

</script>
<style scoped lang="scss">
  .jr-display-name{
    width: 120px;
    text-align: right;
    vertical-align: middle;
    padding-right: 10px;
    color: #676767;
    display: inline-block; 

  }
  .jr-input{
    width: 190px;
  }
  .jr-datetimewhere{
    display: flex;
    flex-direction: row ;
    justify-content: flex-start;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrDatetimewhere.vue